var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page1"},[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.goToDetail}},[_vm._v("点我去详情")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }